import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

const DEFAULTS = {
    tenors:  ['ON', 'TN', 'SN', '1W', '1M', '3M', '6M', '9M', '12M', '24M'],
    brokenDates: [],
    ccyPairs: ['EUR_USD'],
    swapPoints: false
}

const isValid = (forwardOptions) => {
    return forwardOptions && forwardOptions.tenors && forwardOptions.ccyPairs;
}

const CHANGE_FORWARD_OPTIONS = 'DBM/UI/FORWARD/CHANGE_OPTIONS';

export const actionTypes = {
    CHANGE_FORWARD_OPTIONS
};

const changeForwardOptions = createAction(CHANGE_FORWARD_OPTIONS, forwardOptions => ({forwardOptions}));
export const actions = {
    changeForwardOptions
};

export const reducer = handleActions({
    [system.INIT]: () =>
        (state) => {
            return state.setIn(['ui', 'forward', 'options'], DEFAULTS);
        }
    ,

    [CHANGE_FORWARD_OPTIONS]: (payload) =>
        (state) => {
            if (isValid(payload.forwardOptions)) {
                return state.setIn(['ui', 'forward', 'options'], payload.forwardOptions);
            } else {
                return state.setIn(['ui', 'forward', 'options'], DEFAULTS);
            }
        }
});

const getForwardOptions = (state) => state.getIn(['ui', 'forward', 'options']);

export const selectors = {
    getForwardOptions
};
